var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"mainView"}},[_c('loadingDialog'),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.app.mainView),expression:"app.mainView"}]},[_c('keep-alive',[_c('router-view',{attrs:{"name":"keepalive"}})],1),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }